/* Keep Judge.me's review entry module off the initial PDP loading path.
 * Star badges, review data and server-rendered review content remain in place. */
(function () {
  if (window.__drexeyDeferredReviews) return;
  window.__drexeyDeferredReviews = true;
  var entries = {};

  function loadStyles(base, key) {
    return fetch(new URL('manifest.json', base).href).then(function (response) {
      if (!response.ok) throw new Error('Review styles unavailable');
      return response.json();
    }).then(function (manifest) {
      var visited = {};
      function visit(name) {
        if (visited[name]) return;
        visited[name] = true;
        var entry = manifest[name];
        if (!entry) return;
        (entry.css || []).forEach(function (file) {
          var href = new URL(file, base).href;
          var exists = Array.prototype.some.call(document.querySelectorAll('link[rel="stylesheet"]'), function (link) {
            return link.href === href;
          });
          if (exists) return;
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          document.head.appendChild(link);
        });
        (entry.imports || []).forEach(visit);
      }
      visit(key);
    });
  }

  function loadEntry(base, file, key) {
    var url = new URL(file, base).href;
    if (entries[url]) return entries[url];
    entries[url] = loadStyles(base, key).catch(function () {
      // Match the vendor loader: a manifest failure must not prevent the module.
    }).then(function () {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'module';
        script.src = url;
        script.onload = resolve;
        script.onerror = function () {
          script.remove();
          delete entries[url];
          reject(new Error('Review module unavailable'));
        };
        document.head.appendChild(script);
      });
    });
    return entries[url];
  }

  function observeRoot(root) {
    if (root.dataset.drexeyReviewObserved) return;
    root.dataset.drexeyReviewObserved = 'true';
    var widget = root.querySelector('[data-drexey-review-entry-point]');
    var button = root.querySelector('[data-drexey-load-review]');
    if (!widget) return;
    var loading = false;
    var observer;
    function start() {
      if (loading || root.dataset.drexeyReviewLoaded) return;
      var base = window.jdgm && window.jdgm.CDN_BASE_URL;
      if (!base) {
        if (button) button.textContent = 'Retry loading reviews';
        return;
      }
      loading = true;
      if (observer) observer.disconnect();
      if (button) {
        button.disabled = true;
        button.textContent = 'Loading reviews…';
      }
      widget.setAttribute('data-entry-point', widget.getAttribute('data-drexey-review-entry-point'));
      loadEntry(base, widget.getAttribute('data-entry-point'), widget.getAttribute('data-entry-key')).then(function () {
        root.dataset.drexeyReviewLoaded = 'true';
        if (button) button.hidden = true;
      }).catch(function () {
        loading = false;
        if (button) {
          button.disabled = false;
          button.textContent = 'Retry loading reviews';
        }
      });
    }
    if (button) button.addEventListener('click', start);
    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }
    observer = new IntersectionObserver(function (records) {
      if (records.some(function (record) { return record.isIntersecting; })) start();
    }, { rootMargin: '400px 0px' });
    observer.observe(root);
    // Review links may jump directly to the section without a normal scroll.
    if (/^#(?:judgeme|judgeme_product_reviews)$/.test(window.location.hash)) start();
  }

  function init(scope) {
    scope.querySelectorAll('[data-drexey-deferred-review]').forEach(observeRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
